export interface Instructor {
  id: string;
  name: string;
  title: string;
  bio: string;
  avatar: string;
  specialties: string[];
  content: {
    title: string;
    description: string;
    type: 'video' | 'article';
    thumbnail: string;
    url: string;
    duration?: string;
  }[];
}

export const instructors: Instructor[] = [
  {
    id: '1',
    name: 'Sarah Chen',
    title: 'Mindfulness & Meditation Expert',
    bio: 'With over 15 years of experience in mindfulness and meditation, Sarah helps people find inner peace and balance through simple daily practices.',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&auto=format&fit=crop',
    specialties: ['Meditation', 'Stress Management', 'Mindful Living'],
    content: [
      {
        title: 'Introduction to Mindfulness',
        description: 'Learn the basics of mindfulness and how to incorporate it into your daily life',
        type: 'video',
        thumbnail: 'https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?w=800&auto=format&fit=crop',
        url: 'https://www.youtube.com/watch?v=inpok4MKVLM',
        duration: '15 min'
      },
      {
        title: 'Daily Meditation Practice',
        description: 'A guided meditation session for beginners',
        type: 'video',
        thumbnail: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&auto=format&fit=crop',
        url: 'https://www.youtube.com/watch?v=sz7cpV7ERsM',
        duration: '10 min'
      }
    ]
  },
  {
    id: '2',
    name: 'David Park',
    title: 'Breathing & Stress Relief Specialist',
    bio: 'David specializes in breathing techniques and stress management, helping individuals achieve better focus and reduced anxiety.',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&auto=format&fit=crop',
    specialties: ['Breathing Techniques', 'Anxiety Management', 'Performance Enhancement'],
    content: [
      {
        title: 'Advanced Breathing Techniques',
        description: 'Master powerful breathing exercises for stress relief',
        type: 'video',
        thumbnail: 'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?w=800&auto=format&fit=crop',
        url: 'https://www.youtube.com/watch?v=tEmt1Znux58',
        duration: '20 min'
      },
      {
        title: 'Stress Relief Through Breath',
        description: 'Learn how to use your breath to manage stress and anxiety',
        type: 'article',
        thumbnail: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&auto=format&fit=crop',
        url: 'https://example.com/stress-relief'
      }
    ]
  },
  {
    id: '3',
    name: 'Maya Rodriguez',
    title: 'Movement & Exercise Coach',
    bio: 'Maya combines traditional exercise with mindful movement to create holistic fitness experiences that nourish both body and mind.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&auto=format&fit=crop',
    specialties: ['Mindful Movement', 'Yoga', 'Functional Fitness'],
    content: [
      {
        title: 'Mindful Morning Flow',
        description: 'Start your day with this energizing movement routine',
        type: 'video',
        thumbnail: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&auto=format&fit=crop',
        url: 'https://www.youtube.com/watch?v=gwWv7aPcD88',
        duration: '25 min'
      },
      {
        title: 'Desk-Based Movement Breaks',
        description: 'Quick exercises you can do at your desk',
        type: 'video',
        thumbnail: 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?w=800&auto=format&fit=crop',
        url: 'https://www.youtube.com/watch?v=tAUf7aajBWE',
        duration: '8 min'
      }
    ]
  }
];